var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.953,
    height: 28.953,
    viewBox: "0 0 28.953 28.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5c2d91",
    cx: 14.277,
    cy: 14.278,
    rx: 14.277,
    ry: 14.278,
    transform: "translate(0.398 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "M3.888,9A14.278,14.278,0,1,0,24.046,29.158Z",
    transform: "translate(0.892 -4.984)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.619,35.672a.6.6,0,0,1-.446-.187.616.616,0,0,1-.183-.446.625.625,0,0,1,.183-.446.6.6,0,0,1,.446-.192.611.611,0,0,1,.446.192.62.62,0,0,1,.187.446.64.64,0,0,1-.634.634Z",
    transform: "translate(-2.92 -19.051)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.14,26.9H17.971L13.79,20.416a2.677,2.677,0,0,1-.259-.509H13.5a8.353,8.353,0,0,1,.045,1.115V26.9h-.95V18.77h1.236l4.069,6.371q.254.4.33.544h.022a8.6,8.6,0,0,1-.058-1.2V18.77h.95Z",
    transform: "translate(-6.575 -10.395)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.323,26.9H32V18.77h4.123v.861h-3.15v2.7h2.936v.857H32.973v2.82h3.355Z",
    transform: "translate(-17.325 -10.395)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.983,19.631H46.618V26.9h-.95V19.631H43.33V18.77h5.653Z",
    transform: "translate(-23.6 -10.395)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M22.645,44.879a2.2,2.2,0,0,1-1.035.219,1.669,1.669,0,0,1-1.281-.513,1.9,1.9,0,0,1-.482-1.339,1.99,1.99,0,0,1,.54-1.455,1.838,1.838,0,0,1,1.374-.553,2.2,2.2,0,0,1,.892.156v.446a1.785,1.785,0,0,0-.892-.223,1.365,1.365,0,0,0-1.049.446,1.624,1.624,0,0,0-.4,1.151,1.548,1.548,0,0,0,.375,1.093,1.276,1.276,0,0,0,.986.406,1.847,1.847,0,0,0,.977-.25Z",
    transform: "translate(-10.593 -22.838)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M28.59,46.382a1.24,1.24,0,0,1-.95-.4,1.388,1.388,0,0,1-.352-.995,1.446,1.446,0,0,1,.37-1.053,1.339,1.339,0,0,1,.995-.379,1.2,1.2,0,0,1,.932.37,1.463,1.463,0,0,1,.335,1.022,1.437,1.437,0,0,1-.361,1.026A1.267,1.267,0,0,1,28.59,46.382Zm.031-2.441a.817.817,0,0,0-.651.281,1.156,1.156,0,0,0-.241.776,1.093,1.093,0,0,0,.241.75.825.825,0,0,0,.651.277.785.785,0,0,0,.638-.268,1.169,1.169,0,0,0,.223-.767,1.187,1.187,0,0,0-.223-.772A.781.781,0,0,0,28.621,43.942Z",
    transform: "translate(-14.713 -24.122)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M36.121,44.127a.526.526,0,0,0-.326-.085.549.549,0,0,0-.446.259,1.2,1.2,0,0,0-.183.7v1.365H34.72V43.694h.446v.558h0a.937.937,0,0,1,.281-.446.638.638,0,0,1,.419-.156.7.7,0,0,1,.254.036Z",
    transform: "translate(-18.831 -24.173)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M40.8,45.115H38.916a1,1,0,0,0,.228.687.83.83,0,0,0,.634.241,1.338,1.338,0,0,0,.83-.3v.4a1.553,1.553,0,0,1-.932.254,1.133,1.133,0,0,1-.892-.366,1.5,1.5,0,0,1-.326-1.026,1.463,1.463,0,0,1,.352-1.017A1.138,1.138,0,0,1,39.7,43.6a1.008,1.008,0,0,1,.812.339,1.419,1.419,0,0,1,.286.946Zm-.446-.361a.892.892,0,0,0-.178-.576.611.611,0,0,0-.491-.205.692.692,0,0,0-.513.219.986.986,0,0,0-.263.567Z",
    transform: "translate(-20.899 -24.145)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNet);
export default __webpack_public_path__ + "static/media/dotNet.93afb5ca.svg";
export { ForwardRef as ReactComponent };